export default "__VITE_ASSET__Bmv1RTwW__"